var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "url(#paint0_linear_5688_30778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.332 19.6667H18.6654C16.832 19.6667 15.3487 21.1667 15.3487 23.0001L15.332 43.0001C15.332 44.8334 16.832 46.3334 18.6654 46.3334H45.332C47.1654 46.3334 48.6654 44.8334 48.6654 43.0001V23.0001C48.6654 21.1667 47.1654 19.6667 45.332 19.6667ZM45.332 26.3334L31.9987 34.6667L18.6654 26.3334V23.0001L31.9987 31.3334L45.332 23.0001V26.3334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5688_30778",
    x1: 2.58586,
    y1: 7.61801e-7,
    x2: 43.2411,
    y2: 52.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FF2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconRounded);
export default __webpack_public_path__ + "static/media/emailIconRounded.b9961b06483a5c12e131e3ba3d1a76fc.svg";
export { ForwardRef as ReactComponent };